import { Controller } from '@hotwired/stimulus'
import { turboRequest } from '../../helpers/turbo_helper'

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = [
    'visitTypeInput',
    'address',
    'visitCodingField'
  ]

  connect() {
    this.codes = JSON.parse(this.data.get('codes'))

    this.manageVisitTypeInput(this.visitTypeValue() || null)
    this.rerenderForm = this.rerenderForm.bind(this)
    this.searchSelectInputChanged = this.searchSelectInputChanged.bind(this)
    addEventListener('input:change', this.searchSelectInputChanged)
  }

  formEntries() {
    return Object.fromEntries(new FormData(this.element).entries())
  }

  searchSelectInputChanged(event) {
    if (event.detail?.id == 'visit_program_id_input') {
      this.programChange(event.detail.value)
    }
    if (event.detail?.id == 'visit_linkage_id_input') {
      this.clientChange(event.detail.value)
    }
  }

  clientChange(value) {
    if (value) {
      const formParams = this.formEntries()
      formParams["visit[linkage_id]"] = value;
      this.sendturboDataToRerenderForm(formParams)
    }
  }

  programChange(value) {
    if (value) {
      const formParams = this.formEntries()
      formParams["visit[program_id]"] = value;
      this.sendturboDataToRerenderForm(formParams)
    }
  }

  sendturboDataToRerenderForm(formParams) {
    var url = new URL(this.urlValue)
    const params = new URLSearchParams(formParams)

    turboRequest(`${url}?${params}`)
  }

  rerenderForm() {
    this.sendturboDataToRerenderForm(this.formEntries())
  }

  handleVisitTypeInputChange({ target }) {
    this.manageVisitTypeInput(target.value)
  }

  manageVisitTypeInput(value) {
    if (this.hasVisitTypeInputTarget) {
      this.updateAddressField(value)
    }
    if (this.hasVisitCodingFieldTarget) {
      this.updateVisitCodingsOptions(value)
    }
  }

  updateVisitCodingsOptions(value) {
    const codings = this.codes.filter(code => code.visit_type === value)
    let select = this.visitCodingFieldTarget
    const selectedValue = this.visitCodingFieldTarget.value
    select.innerHTML = ''
    codings.forEach(code => {
      const selected = parseInt(selectedValue) === code.id
      select.options[select.options.length] = new Option(code.name, code.id, false, selected)
    })
  }

  updateAddressField(checked) {
    if (checked != 'telepresence') {
      this.addressTarget.classList.remove('d-none')
    } else {
      this.addressTarget.classList.add('d-none')
    }
  }

  visitTypeValue = () => {
    console.log(this.visitTypeInputTargets)
    const elements = this.visitTypeInputTargets.filter(el => el.checked)
    if (elements.length > 0) {
      return elements[0].value
    }
  }

  disconnect() {
    window.removeEventListener('input:change', this.searchSelectInputChanged)
  }
}
